import { SelectMui } from 'src/components/SelectMui'
import TextFieldMui from 'src/components/TextFieldMui'
import { Tooltip } from '@mui/material'
import styled from 'styled-components'
import { Edit } from 'react-feather'

export const Input = styled(TextFieldMui)`
  margin: 0 !important;
  height: 2.3rem;
`

export const Select = styled(SelectMui)`
  margin: 0 !important;
  background-color: white;
`

export const ItemForm = styled.form`
  margin-bottom: 2rem;
`

export const ItemFormContainer = styled.div`
  display: grid; 
  grid-template-columns: 0.2fr 0.5fr 0.2fr;
  grid-template-rows: 50px;  
  gap: 16px;
  margin-bottom: 1.2em;
`
export const ContainerSelect = styled.div`
  display: flex;
  gap: .2rem;
`
export const StyledEditIcon = styled(Edit)`
  cursor: pointer;
  display: flex;
  margin-top: .4rem;
`
export const CellTolltip = styled(Tooltip)`
`
